const numeric = '(?=.*[0-9])';
const lowercase = '(?=.*[a-z])';
const uppercase = '(?=.*[A-Z])';
const special = '(?=.*[!@#\$%\^&])';
function minCharacters(amount) {
    return `(?=.{${amount},})`;
}

const mediumRegex = new RegExp([
    '^',
    '(',
        `(${lowercase}${uppercase})`,
        '|',
        `(${lowercase}${numeric})`,
        '|',
        `(${uppercase}${numeric})`,
    ')',
    minCharacters(6),
].join(''));

const strongRegex = new RegExp([
    '^',
    '(',
        `(${lowercase}${uppercase})`,
        '|',
        `(${lowercase}${numeric})`,
        '|',
        `(${uppercase}${numeric})`,
        '|',
        `(${lowercase}${special})`,
        '|',
        `(${uppercase}${special})`,
    ')',
    minCharacters(8),
].join(''));

const strongerRegex = new RegExp([
    '^',
    '(',
        `(${lowercase}${uppercase}${numeric})`,
        '|',
        `(${lowercase}${uppercase}${special})`,
        '|',
        `(${lowercase}${numeric}${special})`,
        '|',
        `(${uppercase}${numeric}${special})`,
    ')',
    minCharacters(12),
].join(''));

const secureRegex = new RegExp([
    '^',
    numeric,
    special,
    lowercase,
    uppercase,
    minCharacters(16),
].join(''));

export default function (password) {
    if (secureRegex.test(password)) {
        return {
            score: 100,
            description: 'Secure',
        }
    }

    // 12 - 16 chars
    if (strongerRegex.test(password)) {
        let minScore = 75;
        let maxScore = 99;
        let diffScore = maxScore - minScore;
        let minChars = 12;
        let maxChars = 16;
        let diffChars = maxChars - minChars;
        let passwordLength = password.length > maxChars ? maxChars : password.length;
        let scoreAdjustment = (passwordLength - minChars) / diffChars;
        let scoreMultiplier = ((diffScore / minScore) * scoreAdjustment) + 1;

        return {
            description: 'Stronger',
            score: minScore * scoreMultiplier,
        }
    }

    // 8 - 12 chars
    if (strongRegex.test(password)) {
        let minScore = 50;
        let maxScore = 74;
        let diffScore = maxScore - minScore;
        let minChars = 8;
        let maxChars = 12;
        let diffChars = maxChars - minChars;
        let passwordLength = password.length > maxChars ? maxChars : password.length;
        let scoreAdjustment = (passwordLength - minChars) / diffChars;
        let scoreMultiplier = ((diffScore / minScore) * scoreAdjustment) + 1;

        return {
            description: 'Strong',
            score: minScore * scoreMultiplier,
        }
    }

    // 6 - 8 chars
    if (mediumRegex.test(password)) {
        let minScore = 25;
        let maxScore = 49;
        let diffScore = maxScore - minScore;
        let minChars = 6;
        let maxChars = 8;
        let diffChars = maxChars - minChars;
        let passwordLength = password.length > maxChars ? maxChars : password.length;
        let scoreAdjustment = (passwordLength - minChars) / diffChars;
        let scoreMultiplier = ((diffScore / minScore) * scoreAdjustment) + 1;

        return {
            description: 'Medium',
            score: minScore * scoreMultiplier,
        }
    }

    // 0 - 6 chars
    return {
        description: 'Weak',
        score: password.length * (24 / 6) > 24 ? 24 : password.length * (24 / 6),
    }
}
